/*
* Copyright (C) GMS Inc - All Rights Reserved
* This file is part of GMSCloud. - Proprietary and confidential
* Unauthorized copying of this file, via any medium is strictly prohibited
* 
* Created on   : 
* @author      :
* @since       : 0.0.1
* Requirement# :
* Purpose      : Create Bid Wizard Form
* -----------------------------------------------------------------------------
* Revision History
* -----------------------------------------------------------------------------
* Requirement/
* Issue/WorkItem |   DATE    |   AUTHOR  |   DESCRIPTION OF CHANGE
* -----------------------------------------------------------------------------
* 1513          |  25/3/24    |   Nandha  |   Custom dialog usestate problem
*
*/

import React from 'react';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import { DialogTitle, Typography, DialogContent, DialogContentText, DialogActions, Button, Dialog } from '@mui/material';
import { Box } from '@mui/system';

const CustomDialog = ({ open, onClose, success, error, Content, reason}) => {
    const [show, setShow] = React.useState<any>(false);
    const [isHovered, setIsHovered] = React.useState<any>(false);
    const handleClose = () => {
        onClose();
    };

    return (
        <>
            {success && (
                <Dialog open={open} >
                    <DialogTitle className='success'>
                        <Box paddingLeft={8} paddingRight={8}>
                            <Typography textAlign={'center'}>
                                <CheckCircleOutlinedIcon sx={{ fontSize: "50px", color: "white" }} />
                            </Typography>
                            <Typography textAlign={'center'} color='white' fontSize={'20px'} fontWeight={'400'} >
                                Success
                            </Typography>
                        </Box>
                    </DialogTitle>
                    <Box paddingLeft={8} paddingRight={8}>
                    <DialogContent>
                        <DialogContentText textAlign={'center'} fontSize={'18px'} fontWeight={'500'}>
                            {Content}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions style={{ justifyContent: "center" }}>
                        <Button variant='contained' className="successButton" onClick={handleClose}>Ok</Button>
                    </DialogActions>
                    </Box>
                </Dialog>
            )}

            {error &&  (
                <Dialog open={open} >
                    <DialogTitle className='error'>
                        <Box paddingLeft={8} paddingRight={8}>
                            <Typography textAlign={'center'}>
                                <CancelOutlinedIcon sx={{ fontSize: "50px", color: "white" }} />
                            </Typography>
                            <Typography textAlign={'center'} color='white' fontSize={'20px'} fontWeight={'400'} >
                                Error
                            </Typography>
                        </Box>
                    </DialogTitle>
                    <Box paddingLeft={8} paddingRight={8}>
                    <DialogContent>
                        <DialogContentText textAlign={'center'} fontSize={'18px'} fontWeight={'500'}>
                            {Content}
                        </DialogContentText>
                        {reason != undefined && <Box>{!show ? <Typography variant={'body2'} onClick={() => setShow(true)} color={'Highlight'}>show more details</Typography> : <Typography variant={'body2'} onClick={() => setShow(false)} color={'Highlight'}>show less</Typography>}</Box>}
                        {show &&
                        <DialogContentText textAlign={'center'} fontSize={'12px'} fontWeight={'500'} >
                            {reason}
                        </DialogContentText>}
                    </DialogContent>
                    <DialogActions style={{ justifyContent: "center" }}>
                        <Button variant='contained' sx={{ backgroundColor: "#df3333ed" }} onClick={handleClose}>Close</Button>
                    </DialogActions>
                    </Box>
                </Dialog>
            )}
        </>
    );
};

export default CustomDialog;
